import React, { useEffect, useState, useRef } from 'react'

import { useInView } from 'react-cool-inview'

import { string } from 'prop-types'

import { featuredDesignerService } from '../services/featuredDesignerService'

let NewDesignerSection

function FeaturedDesignerSection({ locale = 'en' }) {
  const [loadedComponent, setLoadedComponent] = useState(false)
  const [designersInfo, setDesignersInfo] = useState(null)

  const componentLoadedRef = useRef(false)
  const dataFetchedRef = useRef(false)

  const { observe, inView } = useInView({
    rootMargin: '300px 0px',
    threshold: 0,
    onEnter: ({ unobserve }) => unobserve(),
  })

  useEffect(() => {
    if (!inView) return

    if (!componentLoadedRef.current && !loadedComponent) {
      componentLoadedRef.current = true

      import('Pods/LazyLoaded/NewDesignerSection/NewDesignerSection')
        .then((module) => {
          NewDesignerSection = module.default
          setLoadedComponent(true)
        })
        .catch((err) => {
          componentLoadedRef.current = false
          window.Sentry.captureException(err)
        })
    }

    if (!dataFetchedRef.current && !designersInfo) {
      dataFetchedRef.current = true

      featuredDesignerService
        .getFeaturedDesigner(locale)
        .then((data) => {
          setDesignersInfo(data)
        })
        .catch((err) => {
          dataFetchedRef.current = false
          window.Sentry.captureException(err)
        })
    }
  }, [inView, designersInfo, loadedComponent, locale])

  const hasData = designersInfo && designersInfo.id

  const renderContent = () => {
    if (!hasData || !loadedComponent) {
      return null
    }

    return <NewDesignerSection userInfo={designersInfo} locale={locale} />
  }

  return <div ref={observe} className="featured-designers-container">{renderContent()}</div>
}

FeaturedDesignerSection.propTypes = {
  locale: string,
}

export default FeaturedDesignerSection
